<template>
  <artisio-modal size="m" ref="ReleaseNotesListModal" :visible="modal.show" :content-in-form="false"
                 :title="$t('Release Notes')" @hidden="onHidden" :show-confirmation="false" scrollable
                 :is-loading="modal.loading">
    <artisio-table :items="modal.items" :fields="tableFields">

      <template slot="cell(version)" slot-scope="{item}">
        <span v-as-status>{{ item.version }}</span>
      </template>

      <template slot="cell(release_date)" slot-scope="{item}">
        {{ Formatter.toDateTime(item.date) }}
      </template>

      <template slot="cell(actions)" slot-scope="{item}">
        <b-tooltip :target="`release-notes-btn-${item.uuid}`" :title="$t('Negotiations')"/>
        <b-button :id="`item-negotiation-btn-${item.uuid}`"
                  variant="primary" size="sm" class="ml-2" @click="onReleaseNotesClick(item)">
          <font-awesome-icon icon="file-alt" class="icon"/>
        </b-button>
      </template>

    </artisio-table>
    <template v-slot:modal-footer>
      <cancel-button @click="onHidden">
        {{ $t('Close') }}
      </cancel-button>
    </template>
  </artisio-modal>
</template>

<script>
  import ArtisioModal from "../../artisio-modal/ArtisioModal.vue";
  import CancelButton from "@/core/components/common/CancelButton.vue";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable.vue";
  import i18n from "@/shared/i18n";
  import {Formatter} from "@/core/services/formatter.service";

  const {mapState, mapActions} = createNamespacedHelpers('global')
  export default {
    name: "ReleaseNotesListModal",
    components: {ArtisioTable, CancelButton, ArtisioModal},
    data() {
      return {
        tableFields: [
          {key: "version", label: i18n.t("Version"), sortable: false},
          {key: "release_date", label: i18n.t("Release Date"), sortable: false},
          {key: "actions", label: i18n.t("Release Notes"), sortable: false},
        ]
      }
    },
    computed: {
      Formatter() {
        return Formatter
      },
      ...mapState({
        modal: state => state.releaseNotesListModal
      }),
    },
    methods: {
      ...mapActions(['hideReleaseNotesListModal', 'showReleaseNoteModalPayload']),
      onHidden() {
        this.hideReleaseNotesListModal()
      },
      async onReleaseNotesClick(item) {
        this.showReleaseNoteModalPayload({doNotShowAgainVisible: false, releaseNote: item})
      }
    }
  }

</script>
<style scoped>

</style>